module.exports = __webpack_public_path__ + "static/promo-text-2e780bebb8078edf4214040d1eab8fbe.svg";